// assets
// import { IconLayoutGrid } from '@tabler/icons';

// constant
// const icons = { IconLayoutGrid };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const contractManagement = {
    id: 'contractManagement',
    title: 'Contract Intelligence',
    type: 'group',
    children: [
        {
            id: 'contractManagement',
            title: 'Contract Intelligence',
            titleType:"normal",
            type: 'item',
            url: '/contract-management',           
            icon: "mdi:contract-outline",
            breadcrumbs: false
        }
    ]
};

export default contractManagement;
